<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vs-card title="Client" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
            <h4 style="margin-left: 10px">Customer</h4>
          </div>
          <vs-button
            color="primary"
            class="btn mb-4 md:mb-0 mr-1"
            @click="submitForm"
            v-show="editMode"
          >Save</vs-button>
          <vs-button
            color="primary"
            class="btn mb-4 md:mb-0 mr-1"
            @click="editMode = true"
            v-show="!editMode"
          >Edit</vs-button>
        </div>
        <div class="vx-row mt-6">
          <div class="vx-col md:w-1/4 w-full">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="BP ID *"
                  v-model="data.bp_id"
                  :disabled="editMode? false : true"
                />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="Name *"
                  v-model="data.name"
                  :disabled="editMode ? false : true"
                />
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="Address 1 *"
                  v-model="data.address_1"
                  :disabled="editMode ? false : true"
                />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="Address 2 *"
                  v-model="data.address_2"
                  :disabled="editMode ? false : true"
                />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="PIC "
                  v-model="data.pic"
                  :disabled="editMode ? false : true"
                />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="Email "
                  v-model="data.email"
                  :disabled="editMode ? false : true"
                />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="Phone "
                  v-model="data.phone"
                  :disabled="editMode ? false : true"
                />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input
                  class="w-full"
                  label="Location *"
                  v-model="data.location"
                  :disabled="editMode ? false : true"
                />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Area</label>
                <vs-select
                    class="selectExample"
                    v-model="data.area_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, area)"
                    :disabled="editMode ? false : true"
                >
                    <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Sub Area</label>
                <vs-select
                    class="selectExample"
                    v-model="data.sub_area_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, area)"
                    :disabled="editMode ? false : true"
                >
                    <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample"
                    v-model="data.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                    :disabled="editMode ? false : true"
                >
                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label for class="vs-input--label">Client Type</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="data.client_type_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client_type)"
                    :disabled="editMode ? false : true"
                >
                    <vs-select-item v-for="(item, index) in client_type.data" :key="index" :value="item.id" :text="item.client_type"/>
                </vs-select>
              </div>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      isLoading: false,
      data: {},
      areas: [],
      clients: [],
      clienttypes: [],
      editMode: false,
      area: {
          data: [],
          loading: false,
          endpoint: 'master/areas',
          objectKey: 'village'
      },
      client: {
          data: [],
          loading: false,
          endpoint: 'master/clients',
          objectKey: 'client_code'
      },
      client_type: {
          data: [],
          loading: false,
          endpoint: 'master/clienttypes',
          objectKey: 'client_type'
      },
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      this.$http
        .get("master/customers/" + this.$route.params.id)
        .then(customer => {
          this.data = customer.data;
          /* if(this.area.data.findIndex(a => a.id == customer.data.area_id) === -1) {
            this.area.data.push(customer.data.areas)
          }

          if(this.area.data.findIndex(a => a.id == customer.data.sub_area_id) === -1) {
            this.area.data.push(customer.data.sub_area)
          }

          if(this.client.data.findIndex(a => a.id == customer.data.client_id) === -1) {
            this.client.data.push(customer.data.clients)
          }

          if(this.client_type.data.findIndex(a => a.id == customer.data.client_type_id) === -1) {
            this.client_type.data.push(customer.data.clienttypes)
          } */

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$vs.dialog({
            type: "confirm",
            color: "danger",
            title: "Server Error",
            text: "Try again?",
            accept: () => {
              this.fetchData();
            },
            cancel: () => this.$router.push({name: 'master-customer'}),
            acceptText: "Yes",
            cancelText: "No"
          });
        });
    },
    submitForm() {
      this.isLoading = true;
      this.$http
        .put("master/customers/" + this.$route.params.id + "/update", this.data)
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Saved Successfully",
            iconPack: "feather",
            icon: "icon-check",
            text: "Customer updated successfully"
          });
          this.$router.push({ path: "/master/customer" });
        })
        .catch(error => this.handleError(error))
        .then(() => {
          this.isLoading = false;
        });
    },
    back() {
      if (this.editMode) {
        this.$vs.dialog({
          color: "warning",
          title: "Leave Page",
          text: "Changes you made may not be saved?",
          acceptText: "Leave Page",
          accept: () => {
            this.$router.go(-1);
          }
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>